import {
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'td[eurogard-link-cell]',
  templateUrl: './link-cell.component.html',
  styleUrls: [ './link-cell.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatTooltipModule,
    MatIconModule,
  ],
})
export class LinkCellComponent {

  @Input('eurogard-link-cell')
  public value: any;

  public get href(): string {
    if (this.protocol) {
      return [ this.protocol, this.value ].join(':');
    }
    return this.value;
  }

  @Input()
  public protocol?: 'tel' | 'mailto';

  @Input()
  public short = true;

}
